import React, { useEffect, useRef, useState } from 'react';
import { Search, X, Menu, Ticket, Briefcase, LogIn, LifeBuoy } from "lucide-react";
import { Input } from './ui/input';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { SearchDropdown } from './SearchDropdown';

interface HeaderProps { currentPage: string; onNavigate: (page: string) => void; }

export function Header({ currentPage, onNavigate }: HeaderProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 32);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);
  const searchRef = useRef<HTMLInputElement>(null);
  const menuItems = [
    { icon: Ticket, iconName: "ticket", label: "Eventos", page: "home" },
    { icon: Briefcase, iconName: "briefcase", label: "Produtor", page: "produtor" },
    { icon: LifeBuoy, iconName: "life-buoy", label: "Ajuda", page: "ajuda" },
    { icon: LogIn, iconName: "log-in", label: "Login", page: "login" },
  ];
  const navigate = (page: string) => {
    setMenuOpen(false);
    setIsSearchOpen(false);
    setSearchQuery('');
    onNavigate(page);
  };


  return (
    <header className="unique-header" data-scrolled={scrolled}>
      <div className="unique-container unique-header__inner">
        <button className="unique-header__logo" onClick={() => navigate('home')} aria-label="Unique Ingressos — início">
          <img src="https://app.uniqueingressos.com.br/images/unique-logo.svg" alt="Unique Ingressos" width="108" height="35" />
        </button>
        <div id="header-search" className="unique-header__search"
          onKeyDown={(event) => { if (event.key === 'Escape') setIsSearchOpen(false); }}>
          <div className="unique-header__field">
            <Search size={18} aria-hidden="true" />
            <Input ref={searchRef} type="search" aria-label="Buscar eventos ou cidades"
              placeholder="Buscar eventos ou cidades" value={searchQuery}
              onChange={(event) => { setSearchQuery(event.target.value); setIsSearchOpen(true); }}
              onFocus={() => setIsSearchOpen(true)} />
            {searchQuery && <button aria-label="Limpar busca" onClick={() => { setSearchQuery(''); searchRef.current?.focus(); }}><X size={16} /></button>}
          </div>
          <SearchDropdown query={searchQuery} isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
        </div>
        <nav className="unique-header__nav" aria-label="Navegação principal">
          {menuItems.map((item) => <button key={item.page} data-icon={item.iconName} className={item.page === 'login' ? 'unique-header__login' : undefined}
            onClick={() => navigate(item.page)} aria-current={currentPage === item.page ? 'page' : undefined}>
            <item.icon size={16} aria-hidden="true" />{item.page === 'login' ? 'Entrar' : item.label}
          </button>)}
        </nav>
        <div className="unique-header__mobile-actions">
          <button className="unique-header__login" onClick={() => navigate('login')}><LogIn size={16} aria-hidden="true" />Entrar</button>
          <Popover open={menuOpen} onOpenChange={setMenuOpen}>
            <PopoverTrigger asChild><button className="unique-icon-button unique-header__menu-toggle" aria-label="Abrir menu"><Menu size={20} /></button></PopoverTrigger>
            <PopoverContent className="unique-header__mobile-nav" align="end" sideOffset={12}>
              <nav aria-label="Navegação principal">
                {menuItems.filter((item) => item.page !== 'login').map((item) => <button key={item.page} aria-current={currentPage === item.page ? 'page' : undefined} onClick={() => navigate(item.page)}>{item.label}</button>)}
              </nav>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </header>
  );
}
